/** @jsxImportSource @emotion/react */
import { jsx } from '@emotion/react/macro'
import * as CSS from 'csstype'
import _ from 'lodash'
import { BATTERY_LEVELS } from 'lib/constants'
import { UpdateFirmwareProps } from 'lib/types'
import { ReactComponent as Firmware } from 'static/images/Firmware.svg'
import { ReactComponent as FirmwareUpdate } from 'static/images/Firmware_Update.svg'

export const batteryWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-evenly',
}

// Same palette as the health icons.
const BATTERY_GREEN = '#5FD078'
const BATTERY_YELLOW = '#E89F0B'
const BATTERY_RED = '#F44336'

// Width of the cell inside the battery outline (x 3 → 17).
const BATTERY_CELL_WIDTH = 14

function BatteryIcon({ fill, color }: { fill: number; color: string }) {
  return (
    <svg width="24" height="13" viewBox="0 0 24 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5 3H20.5C20.331 3.00212 20.163 3.02564 20 3.07V1.5C20 0.671573 19.3284 0 18.5 0H1.5C0.671573 0 0 0.671573 0 1.5V11.5C0 12.3284 0.671573 13 1.5 13H18.5C19.3284 13 20 12.3284 20 11.5V9.93C20.163 9.97436 20.331 9.99788 20.5 10H21.5C22.6046 10 23.5 9.10457 23.5 8V5C23.5 3.89543 22.6046 3 21.5 3ZM18 11H2V2H18V11ZM20.5 5V8H21.5V5H20.5Z"
        fill={color}
      />
      {fill > 0 && <rect x="3" y="3" width={BATTERY_CELL_WIDTH * fill} height="7" rx="0.5" fill={color} />}
    </svg>
  )
}

// 100%: full, green · 40–99%: half, green · 20–39%: quarter, yellow · below 20%: empty, red
export function getBatteryIcon(batteryLevel: number) {
  if (_.isNil(batteryLevel)) return
  if (batteryLevel >= BATTERY_LEVELS.FULL) return <BatteryIcon fill={1} color={BATTERY_GREEN} />
  if (batteryLevel >= BATTERY_LEVELS.HALF) return <BatteryIcon fill={0.5} color={BATTERY_GREEN} />
  if (batteryLevel >= BATTERY_LEVELS.QUARTER) return <BatteryIcon fill={0.25} color={BATTERY_YELLOW} />
  return <BatteryIcon fill={0} color={BATTERY_RED} />
}

export function FirmwareIcon({
  iconStyle,
  update,
}: {
  iconStyle: CSS.Properties
  update?: UpdateFirmwareProps
}) {
  return _.isEmpty(update) ? (
    // @ts-ignore
    <Firmware css={iconStyle} />
  ) : (
    // @ts-ignore
    <FirmwareUpdate css={iconStyle} />
  )
}
